
<template>
    <div>
        <div class="position-relative">
          <!-- shape Hero -->
          <section class="section-shaped my-0">
              <div class="shape shape-style-1 shape-default shape-skew bg-gradient-warning bg-image-table">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
              </div>
              <div class="container shape-container d-flex">
                  <div class="col px-0">
                      <div class="row">
                          <div class="col-lg-7">
                              <h1 class="display-3 text-white">{{ $t('about.header') }}</h1>
                              <p class="lead  text-white">{{ $t('about.title') }}</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>
        </div>
        <section class="section section-lg pt-lg-0 mt--200">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6">
                        <div class="card bg-default shadow border-0">
                            <img v-lazy="'/img/tiles/focus.png'" class="card-img-top" alt="Two men using computers">
                            <blockquote class="card-blockquote">
                                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                     class="svg-bg">
                                    <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                                    <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
                                </svg>
                                <h4 class="display-3 font-weight-bold text-white">{{ $t('about.tile') }}</h4>
                            </blockquote>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="pl-md-5">
                            <h3>{{ $t('about.title2') }}</h3>
                            <p class="lead">{{ $t('about.para1') }}</p>
                            <p>{{ $t('about.para2') }}</p>
                            <p>{{ $t('about.para3') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-3 bg-gradient-default shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg pb-300">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">{{ $t('about.title3') }}</h2>
                        <p class="lead text-white">{{ $t('about.paraProduct1') }}</p>
                    </div>
                </div>
                <div class="row row-grid mt-5">
                    <div class="col-lg-4">
                        <icon name="ni ni-settings" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">{{ $t('about.productTitle1') }}</h5>
                        <p class="text-white mt-3">{{ $t('about.product1') }}</p>
                    </div>
                    <div class="col-lg-4">
                        <icon name="ni ni-ruler-pencil" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">{{ $t('about.productTitle2') }}</h5>
                        <p class="text-white mt-3">{{ $t('about.product2') }}</p>
                    </div>
                    <div class="col-lg-4">
                        <icon name="ni ni-atom" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">{{ $t('about.productTitle3') }}</h5>
                        <p class="text-white mt-3">{{ $t('about.product3') }}</p>
                    </div>
                </div>
                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                      <p class="lead text-white">{{ $t('about.paraProduct2') }}</p>
                      <p class="lead text-white">{{ $t('about.paraProduct3') }}</p>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg">
            <div class="container">
                <div class="row justify-content-center text-center mb-lg">
                    <div class="col-lg-8">
                        <h2 class="display-3">{{ $t('about.title4') }}</h2>
                        <p class="lead text-muted">{{ $t('about.paraProjects') }}</p>
                    </div>
                </div>

                <div v-for="projectGroup in groupedProjects" v-bind:key="projectGroup.id"
                    class="row row-grid">
                    <div  v-for="project in projectGroup" v-bind:key="project.id"
                        class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                          <a :href="'/project/'+project.slug">
                            <img v-lazy="project.src"
                                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">{{ project.title }}</span>
                                    <small class="h6 text-muted">{{ project.role }}</small>
                                </h5>
                            </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import projectsData from '../data/projects.js';

export default {
  name: "about",
  components: {},
  data() {
    return {
      projects: projectsData,
      form: {
        name: '',
        email: '',
        text: ''
      }
    }
  },
  computed: {
    groupedProjects() {
      let grouped = [];
      let index = -1;
      for (let i = 0; i < this.projects.length; i++) {
        if (i % 4 == 0) { 
          index++;
          grouped[index] = [];
        }
        grouped[index].push(this.projects[i]);
      }
      return grouped;
    }
  },
  methods: {
    submit: function() {
      this.$refs.form.submit();
    }
  }
};
</script>

<i18n>
{
  "en": {
    "hello": "Hello i18n in SFC English!"
  },
  "nl": {
    "hello": "Hello i18n in SFC Nederlands!"
  }
}
</i18n>